import React, { Component } from "react";
import ListBuild from "../temps/ListBuild";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"; // <-- import styles to be used
import { cat } from "../Data/staticMarkData.json";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

class Marketplace extends Component {
  //org state
  state = {
    userId: "",
    user: "",
    hashPass: "",
    errors: [],
    nutrition: cat.nutrition,
    athletics: cat.athletics,
    misc: cat.misc,
    fullArray: [...cat.nutrition, ...cat.athletics, ...cat.misc],
  };
  //mounts after
  componentDidMount() {
    const { context } = this.props;
    const auth = context.authenticatedUser;
    const hashPass = context.hashPass;
    console.log(hashPass);

    if (auth) {
      console.log(auth);
      this.setState({
        userId: auth.id,
        user: auth,
        hashPass: hashPass,
      });
    }
  }

  //page
  render() {
    const { fullArray, misc, athletics, nutrition} = this.state;
    const results = [];
    const resultsMisc = [];
    const resultsAthletics = [];
    const resultsNutrition = [];
    console.log(fullArray);

    function shuffle(array) {
      let currentIndex = array.length,
        randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex !== 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex],
          array[currentIndex],
        ];
      }

      return array;
    }


    window.addEventListener('resize', (event) => {
      const elm = document.querySelectorAll('.hoverLink')
      const elm2= document.querySelectorAll('.linkDiv')
      const elm3= document.querySelectorAll('#allR')
      if (event.target.innerWidth <= 751) {
        elm3.style.display = 'contents';  
        elm.style.display = 'contents';       
        elm2.style.display = 'contents';
      } else {
        elm3.style.display = 'inline';  
        elm.style.display = 'inline';       
        elm2.style.display = 'inline';
      }
    });


    function starBuild(stars) {
      if (stars === 4.5) {
        return (
          <div className="starDiv" >
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star-half")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-secondary"
              icon={solid("star-half")}
              style={styles.starFlip}
            />
          </div>
        );
      } else if (stars === 5) {
        return (
          <div className="starDiv" >
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon icon={solid("star")} style={styles.starFill} />
          </div>
        );
      } else {
        return (
          <div className="starDiv" >
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-warning"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon
              className="text-secondary"
              icon={solid("star")}
              style={styles.star}
            />
            <FontAwesomeIcon icon={solid("star")} style={styles.starFill} />
          </div>
        );
      }
    }

    for (const obj of athletics) {
      resultsAthletics.push(
        <a
          className="btn btn-dark rounded-pill hoverLink linkDiv"

          href={obj.links}
        >
          <img
            className="rounded-pill bg-light"
            alt="merchandise"
            src={obj.img}
            style={{ height: "120px", width: "120px" }}
          />
          <h3 className="price text-warning" >
            {obj.price}
          </h3>
          <h1 className="text-warning nameTitle">
            {obj.name}
          </h1>

          {starBuild(obj.star)}
        </a>
      );
    }
    for (const obj of nutrition) {
      resultsNutrition.push(
        <a
          className="btn btn-dark rounded-pill hoverLink linkDiv"

          href={obj.links}
        >
          <img
            className="rounded-pill bg-light"
            alt="merchandise"
            src={obj.img}
            style={{ height: "120px", width: "120px" }}
          />
          <h3 className="price text-warning">
            {obj.price}
          </h3>
          <h1 className="text-warning nameTitle">
            {obj.name}
          </h1>

          {starBuild(obj.star)}
        </a>
      );
    }
    for (const obj of misc) {
      resultsMisc.push(
        <a
          className="btn btn-dark rounded-pill hoverLink linkDiv"

          href={obj.links}
        >
          <img
            className="rounded-pill bg-light"
            alt="merchandise"
            src={obj.img}
            style={{ height: "120px", width: "120px" }}
          />
          <h3 className="price text-warning">
            {obj.price}
          </h3>
          <h1 className="text-warning nameTitle">
            {obj.name}
          </h1>

          {starBuild(obj.star)}
        </a>
      );
    }

    for (const obj of fullArray) {
      results.push(
        <a
          className="btn btn-dark rounded-pill hoverLink linkDiv"

          href={obj.links}
        >
          <img
            className="rounded-pill bg-light"
            alt="merchandise"
            src={obj.img}
            style={{ height: "120px", width: "120px" }}
          />
          <h3 className="price text-warning">
            {obj.price}
          </h3>
          <h1 className="text-warning nameTitle">
            {obj.name}
          </h1>

          {starBuild(obj.star)}
        </a>
      );
    }

    return (
      <div className="bounds">
        <span id="span" style={styles.fake}></span>
        <div
          style={{ textAlign: "center", marginTop: "0%", zIndex: -2 }}
          className="grid-33 centered signin bg-dark"
        >
          <ListBuild
                buildN={this.buildN}
                buildAT={this.buildAT}
                buildA={this.buildA}
                buildM={this.buildM}
                next={this.next}
                back={this.back}
                elements={() => (
                  <div
                    style={{
                      display: "inline-grid",
                      width: "70%",
                      textAlign: "center",
                      position: "relative",
                      left: "-1.5%",
                    }}
                  > 
                  <div id="allR" className="active-content">
                  {shuffle(results)}
                  </div>
                  <div id="miscR" className="not-content">
                  {shuffle(resultsMisc)}
                  </div>
                  <div id="athleticR" className="not-content">
                  {shuffle(resultsAthletics)}
                  </div>
                  <div id="nutritionR" className="not-content">
                  {shuffle(resultsNutrition)}
                  </div>
                  </div>
                )}
              />
            
        </div>
      </div>
    );
  }

  //cancel to route
  back = () => {
    this.props.history.push("/");
  };
 
  next = () => {
    this.props.history.push("/reviews/toprated");
  };

  buildN = () => {
    const nutritionR = document.getElementById('nutritionR')
    document.getElementById('span').style.height = "634.5em"
    const miscR = document.getElementById('miscR')
    const athleticsR = document.getElementById('athleticR')
    const allR = document.getElementById('allR')
    nutritionR.className = 'active-content'
    athleticsR.className = 'not-content'
    allR.className = 'not-content'
    miscR.className = 'not-content'
  };

  buildM = () => {
    const nutritionR = document.getElementById('nutritionR')
    document.getElementById('span').style.height = "134.5em"
    const miscR = document.getElementById('miscR')
    const athleticsR = document.getElementById('athleticR')
    const allR = document.getElementById('allR')
    miscR.className = 'active-content'
    athleticsR.className = 'not-content'
    allR.className = 'not-content'
    nutritionR.className = 'not-content'
  };

  buildAT = () => {
    const nutritionR = document.getElementById('nutritionR')
    document.getElementById('span').style.height = "634.5em"
    const miscR = document.getElementById('miscR')
    const athleticsR = document.getElementById('athleticR')
    const allR = document.getElementById('allR')
    athleticsR.className = 'active-content'
    miscR.className = 'not-content'
    allR.className = 'not-content'
    nutritionR.className = 'not-content'
  };

  buildA = () => {
    const nutritionR = document.getElementById('nutritionR')
    document.getElementById('span').style.height = "1384.6em"
    const miscR = document.getElementById('miscR')
    const athleticsR = document.getElementById('athleticR')
    const allR = document.getElementById('allR')
    allR.className = 'active-content'
    miscR.className = 'not-content'
    athleticsR.className = 'not-content'
    nutritionR.className = 'not-content'
  };
}

//styles
const styles = {


  star: {
    fontSize: 30,
    position: "relative",
  },
  starFlip: {
    fontSize: 30,
    position: "relative",
    transform: "rotateY(180deg)",
    left: "-17%",
  },
  starFill: {
    fontSize: 30,
    position: "relative",
    transform: "rotateY(180deg)",
    left: "-16.5%",
    zIndex: "-5",
  },

  starDiv: {
    display: "inline-flex",
    position: "relative",
    right: "1.5%",
    top: "25%",
  },
  fake: {
    position: "absolute",
    height: "1384.6em",
    width: "75%",
    zIndex: -0,
    right: "12.5%",
    backgroundColor: "#3D3D3D",
  },
};

export default Marketplace;
